// extracted by mini-css-extract-plugin
export default {"noTemplates":"styles_noTemplates__eBW8F","noTemplatesIcon":"styles_noTemplatesIcon__qGal7"};